import { useSelector } from "react-redux";

export const useNotificationSelector = () => {
  return useSelector((state) => state.notification)
}
